import { createLogger } from 'redux-logger';

const loggerMiddleware = createLogger();

export default loggerMiddleware;
